import {
  createSelector, createSlice, PayloadAction,
} from '@reduxjs/toolkit';
import moment, { Moment, MomentInput } from 'moment-timezone';

export interface LocalizationState {
  useLocalTime: boolean;
  locale: string;
  eventTimezone: string;
}

type MomentLocalizer = (time: MomentInput) => Moment;

const initialState: LocalizationState = {
  useLocalTime: true,
  eventTimezone: moment.tz.guess(),
  locale: 'en',
};

export const selectLocalizationState = (state: any) => state.localization as LocalizationState;
export const selectMomentLocalizer: ((state: any) => MomentLocalizer) = createSelector(
  [selectLocalizationState],
  (state: LocalizationState) => {
    const { eventTimezone } = state;
    return state.useLocalTime
      ? (time) => moment(time).local()
      : (time) => moment(time).tz(eventTimezone);
  },
);

export const selectLocale = (state: any) => state.localization.locale;

export const localizationSlice = createSlice({
  name: 'localization',
  initialState,
  reducers: {
    setUseLocalTime: (state, action: PayloadAction<boolean>) => {
      state.useLocalTime = action.payload;
    },
    setEventTimeZone: (state, action: PayloadAction<string>) => {
      state.eventTimezone = action.payload;
    },
    setLocale: (state, action: PayloadAction<string>) => {
      state.locale = action.payload;
    },
  },
});

export default localizationSlice.reducer;
